import React from "react";
import { Link, Box, Typography, Tooltip } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import { useCourse } from "../../pages/course/hooks";

export function IRGradingCard({ grade, id, deleteGrade }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const badgeStyles = styles.badgeOrange;
  const { diagnosticList } = useCourse();

  const getCourseName = (courseId) => {
    const course = diagnosticList?.find((course) => course?.id === courseId);
    return course?.courseName;
  };

  const getGrade = (item) => {
    let _grade = grade?.diagnosticOne?.nextLevelAssessments?.find(
      (level) => level?.id === item?.id,
    );
    const gradeName = _grade?.gradeName;
    return gradeName;
  };

  return (
    <Box
      sx={{
        borderRadius: "10px",
        background: "var(--mui-palette-gray-lightGray50)",
        boxShadow: "0 5px 10px rgba(0, 0, 0, 0.1)",
        maxWidth: "400px",
        padding: "15px 5px 5px 15px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "all .5s ease-in-out",
        position: "relative",
        overflow: "hidden",
        "&:hover": {
          background: "var(--mui-palette-primary-blue)",
          boxShadow: "0 20px 40px rgba(61,65,84,.15)",
          transform: "translateY(-2px)",
          transition: "all .5s ease-in-out",
          "& h6, & a, & .MuiSvgIcon-root, & .MuiBox-root": {
            color: "var(--mui-palette-common-white)",
          },
        },
        "&::before": {
          content: '""',
          display: "block",
          height: "5px",
          width: 0,
          position: "absolute",
          left: 0,
          top: 0,
          backgroundColor: "var(--mui-palette-primary-orange)",
          transition: "all .5s ease-in-out",
        },
        "&:hover:before": {
          width: "100%",
        },
        "& > *": {
          position: "relative",
          zIndex: 1,
        },
      }}
    >
      <Box>
        <Typography
          color="common.black"
          align="left"
          variant="h6"
          sx={{
            mb: 1.2,
            fontSize: "1rem",
            lineHeight: 1.4,
            minHeight: "40px",
            fontWeight: "bold",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
            textOverflow: "ellipsis",
            paddingRight: "50px",
          }}
        >
          {getCourseName(grade?.diagnosticOne?.courseId)}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box key={id} sx={{ ...styles.badge, ...badgeStyles }}>
            {grade?.diagnosticOne?.applicableGrades
              ? grade?.diagnosticOne?.applicableGrades?.map((item, id) => {
                  return <span key={id}>{item?.grade}</span>;
                })
              : ""}
          </Box>
          <Box
            sx={{
              ...styles.badge,
              ...((grade?.studentType || "URBAN").toUpperCase() === "RURAL"
                ? styles.badgeGreen
                : styles.badgeOrange),
            }}
          >
            {(() => {
              const t = (grade?.studentType || "URBAN").toUpperCase();
              return t.charAt(0) + t.slice(1).toLowerCase();
            })()}
          </Box>
        </Box>
        <Box sx={styles.courseDetail}>
          <Box sx={styles.detailItem}>
            <Box sx={styles.itemHeading}>Second Diagnostic Tests :</Box>
            <Box sx={styles.itemValue}>
              {grade?.diagnosticTwo
                ? grade?.diagnosticTwo?.map((item, index) => {
                    return (
                      <span key={index}>
                        {" "}
                        {getGrade(item)} - {getCourseName(item?.courseId)}{" "}
                        <br />
                      </span>
                    );
                  })
                : ""}
            </Box>
            {/* <Box sx={styles.itemHeading} mt={1}>Applicable Levels :</Box>
                        <Box sx={styles.itemValue} >
                            <Box>
                                {grade?.diagnosticOne || grade?.diagnosticTwo
                                    ? [...new Set(
                                        [
                                            ...(grade?.diagnosticOne?.nextLevelAssessments?.map((assessment) => assessment?.irLevel) || []),
                                            ...(grade?.diagnosticTwo?.flatMap((item) => item?.nextLevelAssessments?.map((assessment) => assessment?.irLevel)) || [])
                                        ].filter(Boolean) // Removes empty strings, null, or undefined values
                                    )].map((level, index) => (
                                        <span key={index} >{level},&nbsp;</span>
                                    ))
                                    : ''}
                            </Box>
                        </Box> */}
          </Box>
        </Box>
      </Box>
      <Box sx={styles.actionBtn}>
        {grade?.answerDetails?.options?.helpText?.text && (
          <Tooltip title={grade?.answerDetails?.options?.helpText?.text}>
            <InfoIcon
              sx={{
                color: "var(--mui-palette-primary-button)",
                fontSize: "1.2rem",
              }}
            />
          </Tooltip>
        )}

        {/* {(grade?.updateHistory[0]?.updatedBy === user.userName)
                    && */}
        <Link
          style={styles.actionBtnItem}
          href={`/ir-grading/edit/${grade?.irGradingId}`}
          title="Edit Grading"
        >
          <CreateIcon
            sx={{
              color: "var(--mui-palette-primary-button)",
              fontSize: "1.2rem",
            }}
          />
        </Link>
        {/* } */}
        {/* {(grade?.updateHistory[0]?.updatedBy === user.userName)
                    && */}
        <Link
          style={styles.actionBtnItem}
          onClick={(e) => deleteGrade(grade?.irGradingId)}
          title="Delete Grading"
        >
          <DeleteIcon
            sx={{ color: "var(--mui-palette-error-dark)", fontSize: "1.2rem" }}
          />
        </Link>
        {/* } */}
      </Box>
    </Box>
  );
}

const styles = {
  courseDetail: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    marginTop: "15px",
  },
  detailItem: {
    marginBottom: "10px",
  },
  itemHeading: {
    color: "var(--mui-palette-primary-blue)",
    fontSize: "1rem",
    fontWeight: 600,
    marginBottom: "5px",
  },
  itemValue: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "0.8rem",
    minHeight: "32px",
  },
  badge: {
    padding: "6px 10px",
    backgroundColor: "var(--mui-palette-primary-orange)",
    marginRight: "1rem",
    borderRadius: "6px",
    fontSize: ".7rem",
    fontWeight: "600",
    letterSpacing: "0.5px",
  },
  badgeGreen: {
    backgroundColor: "var(--mui-palette-primary-dark)",
    color: "var(--mui-palette-common-white)",
  },
  badgeOrange: {
    color: "var(--mui-palette-common-white)",
    backgroundColor: "var(--mui-palette-primary-orange)",
  },
  actionBtn: {
    textAlign: "right",
    position: "absolute",
    top: "10px",
    right: "10px",
    padding: "5px",
  },
  actionBtnItem: {
    marginLeft: "5px",
    marginRight: "5px",
    cursor: "pointer",
  },
};

export default IRGradingCard;
